// 接口域名和状态码的全局配置文件
import translate from '@/api/translate';
export default {
	// 接口配置
	method: "GET", // 默认请求方式
	request_host: process.env.VUE_APP_API_BASE_URL, // 接口域名
	login_api: '/admin/login', // 登录接口
	refresh_token_api: '/refreshToken', // 刷新token的API
	uploadFile_host: process.env.VUE_APP_API_BASE_URL, // 上传文件接口域名
	uploadFile_api: '/admin/upload', // 上传文件API
	uploadFile_loading_txt: '上传图片中', // 上传图片默认loading显示的文字
	request_no_token_code: 4000, // 请求没有携带token的code值
	request_token_error: 4001, // 被踢下线
	request_token_overdue_code: 4002, // token过期的code值
	request_bing_phone: 2001, // 需要绑定手机号,小程序中会返回session_key
	request_token_unable_renew: 6001, // token无法续期；
	request_password_changed: 6002, // 密码已修改，请重新登录；
	request_user_deleted: 6003, // 用户已被删除/已注销；

	// websocket
	websocket: {
		url: process.env.VUE_APP_API_WEBSOCKET_URL,
		heartbeat: 15, // 心跳时间，秒
		maxReconnectionNum: 3600, // 失败或错误后，最大重连次数
		action: {
			error: 'error',
			login: "login", // 登录
			ping: "ping", // 心跳包
		}, // action数据类型
	},

	// 表格/分页区域配置
	PagesSize: [50, 100, 150], // 分页每页显示条数
	HeaderCellStyle: {
		"color": "#1F2D48",
		"font-size": "15px",
		"font-weight": "blod",
		"background": "#F6F6F8",
		"text-align": "center",
	}, // 表格表头样式
	CellStyle: {
		"color": "#1F2D48",
		"font-size": "14px",
		"padding": "16px 0",
		"text-align": "center",
	}, // 表格每一条样式
	StatusList: [{
		value: 1,
		label: translate.ShowText('启用'), // 启用
	}, {
		value: 0,
		label: translate.ShowText('禁用'), // 禁用
	}], // 禁用启用配置参数
	QualityList: [{
		value: 1,
		label: translate.ShowText('先进先出'), // 先进先出
	}, {
		value: 2,
		label: translate.ShowText('先到期先出'),
	}], // 策略配置参数
	InWarehouseStatus: [{
		value: 0,
		label: translate.ShowText('全部')
	}, {
		value: 40,
		label: translate.ShowText('待上架')
	}, {
		value: 90,
		label: translate.ShowText('已完成')
	}], // 入库订单状态筛选
	OutWarehouseStatus: [{
		value: 0,
		label: translate.ShowText('全部')
	}, {
		value: 10,
		label: translate.ShowText('待指派')
	}, {
		value: 30,
		label: translate.ShowText('待复核')
	}, {
		value: 90,
		label: translate.ShowText('已完成')
	}], // 出库订单状态筛选
	LedgerType: [{
		value: 1,
		label: translate.ShowText('入库'),
	}, {
		value: 2,
		label: translate.ShowText('出库'),
	}], // 库存台账类型
	InventoryStatus: [{
		value: 0,
		label: translate.ShowText('全部')
	}, {
		value: 10,
		label: translate.ShowText('待完成')
	}, {
		value: 20,
		label: translate.ShowText('待审核')
	}, {
		value: 30,
		label: translate.ShowText('已完成')
	}],
	InventoryType: [{
		value: 1,
		label: translate.ShowText('暗盘')
	}, {
		value: 2,
		label: translate.ShowText('明盘')
	}],
	AuthTypeList: [{
		value: 1,
		label: translate.ShowText('总仓'),
	}, {
		value: 2,
		label: translate.ShowText('子仓'),
	}, {
		value: 3,
		label: "PDA", // PDA
	}],
	AllocationManageStatus: [{
		value: 10,
		label: translate.ShowText('待审核')
	}, {
		value: 30,
		label: translate.ShowText('待出库验货')
	}, {
		value: 40,
		label: translate.ShowText('待生成入库单')
	}, {
		value: 60,
		label: translate.ShowText('待入库验货')
	}, {
		value: 70,
		label: translate.ShowText('待入库上架')
	}, {
		value: 80,
		label: translate.ShowText('已完成')
	}],
	RelocationStatus: [{
		value: 20,
		label: translate.ShowText('待完成')
	}, {
		value: 30,
		label: translate.ShowText('已完成')
	}]
};